import { Dropdown } from '@instinet-analytics/semantic-ui-components';
import { benchmarkOptions } from './options';
import React, { useCallback } from 'react';
import { getProfileOptions } from 'widgets/estimatedTradeCost/components/options';

import './BenchmarkDropdown.scss';

export function BenchmarkDropdown({
    benchmark,
    profile,
    onChanged,
    bottom,
}: {
    benchmark: string | undefined;
    bottom?: boolean;
    profile: string | undefined;
    onChanged: (nextBenchmark: string, nextProfile: string) => void;
}) {
    const onBenchmarkChanged = useCallback(
        (nextBenchmark: string) => {
            let nextProfile = profile;
            const nextProfileOptions = getProfileOptions(nextBenchmark);
            if (!nextProfileOptions.find((o) => o.value === profile)) {
                nextProfile = nextProfileOptions[0].value;
            }
            onChanged(nextBenchmark, nextProfile!);
        },
        [profile, onChanged]
    );

    return (
        <Dropdown
            className="benchmark-dropdown"
            onChange={onBenchmarkChanged}
            value={benchmark}
            placeholder="Select a Benchmark"
            options={benchmarkOptions}
            bottom={bottom}
        />
    );
}
